import axios from "./axios";

class CCTransferService {
  getRedirectURL = async (service_type) => {
    try {
      const response = await axios.post("/cc_transfer/redirect_url", {
        service_type,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new CCTransferService();
